import Vue from 'vue'
import Router from 'vue-router'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

const constantRoutes = [{
  path: '/',
  redirect: '/layout',
}, {
  path: '/layout',
  redirect: '/layout/index',
  component: () => import('@/views/layout.vue'),
  children: [{
    path: 'login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
  }, {
    path: 'registry',
    name: 'registry',
    component: () => import('@/views/registry/index.vue'),
  }, {
    path: 'resetPassword',
    name: 'resetPassword',
    component: () => import('@/views/resetPassword/index.vue'),
  }, {
    path: 'help',
    name: 'help',
    component: () => import('@/views/help/index.vue'),
  }, {
    path: 'axt',
    name: 'axt',
    component: () => import('@/views/axt/index.vue'),
  }, {
    path: 'my-info',
    name: 'my-info',
    component: () => import('@/views/my/info.vue'),
  }, {
    path: 'my-look',
    name: 'my-look',
    component: () => import('@/views/my/look.vue'),
  }, {
    path: 'video-tip',
    name: 'video-tip',
    component: () => import('@/views/tip/video.vue'),
  }, {
    path: 'index',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
  }, {
    path: 'about',
    name: 'about',
    component: () => import('@/views/about/index.vue'),
    children: [{
      path: ':id',
      name: 'about-detail',
      component: () => import('@/views/about/detail.vue'),
    }]
  }, {
    path: 'info',
    name: 'info',
    component: () => import('@/views/info/index.vue'),
    children: [{
      path: ':id',
      name: 'info-detail',
      component: () => import('@/views/info/detail.vue'),
    }]
  }, {
    path: 'news',
    name: 'news',
    component: () => import('@/views/news/index.vue'),
    children: [{
      path: ':id',
      name: 'news-list',
      component: () => import('@/views/news/list.vue'),
    }]
  }, {
    path: 'publicWelfare',
    name: 'publicWelfare',
    component: () => import('@/views/publicWelfare/index.vue'),
  }, {
    path: 'video',
    name: 'video',
    component: () => import('@/views/video/index.vue'),
  }, {
    path: 'video-sec',
    name: 'video-sec',
    component: () => import('@/views/video/secList.vue'),
  }, {
    path: 'contentDetail',
    name: 'contentDetail',
    component: () => import('@/views/content/common.vue'),
  }, {
    path: 'videoDetail',
    name: 'videoDetail',
    component: () => import('@/views/content/video.vue'),
  }, {
    path: 'mInput',
    name: 'mInput',
    component: () => import('@/views/mInput/index.vue'),
  }, {
    path: 'question',
    name: 'question',
    component: () => import('@/views/question/index.vue'),
  }, {
    path: 'question-success',
    name: 'question-success',
    component: () => import('@/views/question/success.vue'),
  }]
}, {
  path: '/land',
  name: 'land',
  component: () => import('@/views/land/index.vue'),
}, {
  path: '*',
  redirect: () => {
    return {
      name: 'index'
    }
  }
}]

const router = new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})

export default router